import(/* webpackMode: "eager" */ "/app/apps/sb-shell/app/not-found.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/sb-shell/components/footer/siteFooter/SiteFooterLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/sb-shell/components/TopNavigation/TopNavigationBar.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.15_@babel+core@7.29.0_@opentelemetry+api@1.9.1_babel-plugin-macros@3.1.0_reac_3f28ddaa1605f4101401bbc5bc6121ac/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/builder/clientUtils.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/runtime-configuration/src/PublicConfigurationContext.tsx");
